import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorDocumentType = v.object({
	name: v.string(),
	description: v.optional(v.string()),
	code: v.string(),
	internalControl: internalControl,
});

export const documents_types = defineTable(validatorDocumentType)
	.index("by_company_id", ["internalControl.companyId"]) // Relación con empresas
	.index("by_company_and_branch", [
		"internalControl.companyId",
		"internalControl.branchId",
	]);
